export default __webpack_public_path__ + "596ef3b0385dd14fab41facd08475f76.png";